import React from "react"

const SARCurrency = ({ width = 16, height = 18, fill = "white", ...props }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M9.36633 2.63343C10.0415 1.87558 10.4564 1.53534 11.2713 1.10518V13.7248L9.36633 14.1184V2.63343Z"
                fill={fill}
            />
            <path
                d="M15.4529 8.97797C15.8478 8.14438 15.8943 7.7739 16 6.91875L1.39805 10.0894C1.05179 10.8607 0.940326 11.2919 0.886964 12.0576L15.4529 8.97797Z"
                fill={fill}
            />
            <path
                d="M15.4529 12.8433C15.8478 12.0097 15.8943 11.6392 16 10.7841L9.43602 12.1734C9.38956 12.9375 9.44292 13.3295 9.38956 14.0953L15.4529 12.8433Z"
                fill={fill}
            />
            <path
                d="M15.4529 16.7081C15.8478 15.8745 15.8943 15.504 16 14.6489L10.0168 15.9477C9.7148 16.3645 9.52895 17.0592 9.38956 17.9601L15.4529 16.7081Z"
                fill={fill}
            />
            <path
                d="M5.95136 15.392C6.53213 14.6742 7.13614 13.7711 7.5543 13.0301L0.51109 14.5568C0.164822 15.3281 0.0533618 15.7592 0 16.525L5.95136 15.392Z"
                fill={fill}
            />
            <path
                d="M5.64935 1.56829C6.32448 0.810437 6.73938 0.470197 7.5543 0.0400391V13.0765L5.64935 13.4701V1.56829Z"
                fill={fill}
            />
        </svg>
    )
}

export default SARCurrency
